import React, { useMemo } from "react";
import { UseFormReturn } from "react-hook-form";
import { DrawerHeader } from "@/components/ui/drawer";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";
import { Step } from "./constants";
import Card from "@/components/custom/card";
import { useTranslation } from "react-i18next";
import { useGetVessels } from "@/services/queries/vessel";
import Loading from "@/components/custom/loading";
import { InvoiceFormValues } from "./index";

const CostCenter = ({
  form,
  setStep,
}: {
  form: UseFormReturn<InvoiceFormValues>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const { t } = useTranslation();
  const { data: vesselsData, isPending } = useGetVessels();

  const vessels = useMemo(() => {
    return vesselsData?.value || [];
  }, [vesselsData]);

  return (
    <div>
      <DrawerHeader
        title={t("title.cost_center")}
        leftButton={
          <button
            type="button"
            onClick={() => setStep(Step.INITAL)}
            className="w-6"
          >
            <CaretLeft color="#E3EDFC" size={18} />
          </button>
        }
        rightButton={<span className="w-6" />}
      />

      <p className="mx-auto max-w-[210px] text-center text-sm font-medium leading-[18px] text-[#98B2D3]">
        {t("description.cost_center")}
      </p>

      {isPending ? (
        <Loading className="mt-10" />
      ) : (
        <div className="mt-5 space-y-[15px]">
          {vessels?.map((vessel) => (
            <Card
              data-testid={`invoice-form-cost-center-item-${vessel.id}`}
              onClick={() => {
                form.setValue("budgetId", "");
                form.setValue("vesselId", vessel.id);
                form.setValue(
                  "lineItems",
                  form.watch("lineItems").map((lineItem) => ({
                    ...lineItem,
                    budgetSubcategoryId: undefined,
                  }))
                );
                setStep(Step.INITAL);
              }}
              className="px-[15px] py-[14px]"
              key={vessel.id}
            >
              <div className="flex flex-col items-start justify-between gap-3">
                <span className="text-[15px] font-medium leading-[18px] text-white">
                  {vessel.name}
                </span>
                {vessel.notes && (
                  <span className="text-[13px] font-medium leading-4 text-white/[66%]">
                    {vessel.notes}
                  </span>
                )}
              </div>
              <CaretRight color="#E3EDFC" size={18} />
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default CostCenter;
